export default __webpack_public_path__ + "static/media/create-web-not-created.454c94fa.svg";